<template>
  <div class="miancontent">
    <!-- 返回键 -->
    <!-- <div class="back" @click="back()">
      <i></i>
      <span>返回</span>
    </div> -->
    <el-card class="mian_box">
      <div class="custom-tree-container">
        <div class="block">
          <div class="head_box">
            <p>{{ $parent.textOne }}</p>
            <p>操作</p>
          </div>
          <!-- <p>使用 render-content</p> -->
          <el-tree
            :data="threeedata"
            :show-checkbox="false"
            node-key="ID"
            :props="propss"
            :default-expanded-keys="defaultExpandedKey"
            :expand-on-click-node="false"
          >
            <span class="custom-tree-node" slot-scope="{ data, node }">
              <span>{{ data.Name }}</span>
              <span>
                <el-button
                  size="mini"
                  type="text"
                  v-if="data.Childs === undefined || data.Childs.length == 0"
                  @click="importtest(data, node)"
                >
                  导入试题
                </el-button>
                <el-button
                  size="mini"
                  @click="looktest(node)"
                  type="text"
                  v-if="data.TestCount > 0"
                >
                  查看试卷
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="() => append(data, node, 'tongji')"
                  v-if="data.Childs !== undefined"
                >
                  增加同级
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="() => append(data, node)"
                  v-if="data.Childs !== undefined"
                >
                  增加子级
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="() => ModifyThe(data, node)"
                >
                  修改
                </el-button>
                <el-button
                  size="mini"
                  type="text"
                  @click="() => remove(data, node)"
                >
                  删除
                </el-button>
              </span>
            </span>
          </el-tree>
        </div>
        <!-- 添加试题的弹窗 -->
        <div class="bulkImportExaminee">
          <el-dialog
            title="导入试题"
            :visible.sync="dialogBoxVisible"
            :close-on-click-modal="false"
          >
            <div class="dialogBox">
              <el-input
                autocomplete="off"
                :placeholder="filename"
                class="pointer"
                readonly
              ></el-input>
              <el-upload
                class="upload-demo"
                ref="upload"
                action=""
                multiple
                :limit="1"
                :show-file-list="false"
                :on-change="uploadPreview"
                :auto-upload="false"
              >
                <el-button type="primary" class="upoload"
                  >选择文件上传试题</el-button
                >
              </el-upload>
              <!-- <div slot="tip" class="el-upload__tip">
                只能上传excel文件，且不超过10MB
              </div> -->
              <input
                type="file"
                id="files"
                ref="refFile"
                style="display: none"
              />
            </div>
            <div class="downloadExcel">
              <div class="left_view">
                <img src="../../../../assets/qusetionbank/word.png" alt="" />
                <el-button @click="docDownload">下载WORD文档模板</el-button>
              </div>
              <div class="right_view">
                <img src="../../../../assets/qusetionbank/excel.png" alt="" />
                <el-button @click="excelDownload">下载EXCEL文档模板</el-button>
              </div>
              <!-- <a
                href="api/download/试题录题模板.xls"
                target="_self"
                download="添加考生模板.xls"
                >试题录题模板</a
              > -->
            </div>
            <div class="instructions">
              <h4>批量导入说明</h4>
              <p>
                目前模板整理支持选择题（单选题、多选题、判断题），主观题（填空题、问答题），共用
                题干（共用题干单选题、共用题干不定项选择题），共用选项（配伍题）。
              </p>
            </div>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogBoxVisible = false">取 消</el-button>
              <el-button type="primary" @click="send" :loading="isState"
                >确 定</el-button
              >
            </div>
          </el-dialog>
        </div>
      </div>
    </el-card>
    <!-- 上传试题成功弹窗 -->
    <div class="delete_view">
      <el-dialog
        title="温馨提示"
        :visible.sync="successfulVisible"
        :close-on-click-modal="false"
      >
        <div class="delete_mian">
          <p>考题 "{{ filedata.name }}"</p>
          <p>
            导入数据共:{{ succeedNum }}题; 成功:
            <span class="green">{{ succeedNum }}题;</span>
          </p>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="successfulVisible = false">我知道了</el-button>
        </span>
      </el-dialog>
    </div>
    <!-- 上传试题失败弹窗 -->
    <div class="eroor_view">
      <el-dialog
        title="温馨提示"
        :visible.sync="failureVisible"
        :close-on-click-modal="false"
      >
        <div class="eroor_mian">
          <p v-if="flang == 1">
            <span class="mgr_20"> 考题{{ filedata.name }}</span>
            错误：<span class="red">{{ failureData.length }}题</span>
          </p>
          <p v-if="flang == 0">
            <span class="mgr_20"> 考题{{ filedata.name }}</span>
            错误：<span class="red"
              >{{ falngSum == null ? "0" : falngSum }}题</span
            >
          </p>
          <div class="eroor_form">
            <el-table
              ref="tabledata"
              :data="failureData"
              style="width: 100%"
              :row-class-name="tableRowClassName"
              :header-cell-style="{
                'background-color': '#8FCBFF',
                color: '#333333',
                height: '60px',
              }"
            >
              <el-table-column label="序号" width="80">
                <template slot-scope="scope">
                  {{ scope.$index + 1 }}
                </template>
              </el-table-column>
              <el-table-column label="题干" prop="paragraph"></el-table-column>
              <el-table-column label="错误信息" v-if="flang == 1">
                <template slot-scope="scope">
                  {{ scope.row.index }},{{ scope.row.msg }}
                </template>
              </el-table-column>
              <el-table-column label="错误信息" v-if="flang == 0">
                <template slot-scope="scope">
                  {{ scope.row.errorMsg }}
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="failureVisible = false">我知道了</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  ChapterThree,
  ChapterManager,
  Update,
  Delete,
  ImportExcel,
  importWord,
} from "@/api/quebankmana.js";
import loginvuex from "@/store/index";
export default {
  data() {
    return {
      threeedata: [],
      filename: "", //文件名
      filedata: "", //文件的内容
      isfuappclassid: "", //最大的appip
      isselectdata: "", //当前选中的章节信息。
      dialogBoxVisible: false, //添加试题的弹窗。
      successfulVisible: false, // 试题上传成功弹窗
      failureVisible: false, //试题上传失败的弹窗
      failureData: [], // 错误上传返回的表格数据
      flang: 0, // 判断是word还是excel的错误题数
      falngSum: 0, // word错误题数
      isState: false, // 防抖
      succeedNum: "",
      propss: {
        children: "Childs",
        label: "ID",
        key: "ID",
      },
      changeTotol:'',
      defaultExpandedKey: [], //默认展示节点数组
    };
  },
  props: ["cutcoms"],
  methods: {
    back() {
      this.cutcoms(0);
      this.$destroy();
    },
    looktest(nodes) {
      this.$parent.$parent.islooktestid = nodes.label;
      this.$parent.$parent.islooktestname = nodes.data.Name;
      this.$parent.$parent.isedit = 0;
      console.log(this.$parent.isedit);
      this.cutcoms(4);
    },
    // 表格背景颜色
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex % 2 === 1) {
        return "success-row";
      } else if (rowIndex % 2 === 0) {
        return "warning-row";
      }
      return "";
    },
    // 增加同级
    addSibling(items, nodes) {
      console.log("增加同级");
      console.log(items);
      console.log(nodes);
    },
    // 增加子级
    append(items, nodes, istong) {
      console.log(items);
      // console.log(istong);
      let parmas = {
        AppID: "",
        ParentID: "",
        ChapterName: "",
        UserID: JSON.parse(loginvuex.state.userlist).userID,
        Level: "",
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
        _examID: "",
      };
      if (istong == "tongji") {
        parmas.Level = nodes.level;
      } else {
        parmas.Level = nodes.level + 1;
      }
      if (nodes.level == 1) {
        //下一级是题目的第一级。
        parmas.AppID = nodes.label;
        parmas.ParentID = -1;
        if (istong == "tongji") {
          //同级新增的情况下。
          parmas.AppID = -1;
          parmas.ParentID = this.$parent.$parent.isselectitems.AppClassID;
        }
        this.$prompt("请输入名称", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValidator: this.checkfunc,
          closeOnClickModal: false,
        })
          .then(({ value }) => {
            this.$message({
              type: "success",
              message: "添加: " + value + "成功",
            });
            parmas.ChapterName = value;
            ChapterManager(parmas);
            this.getthreedata();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消输入",
            });
          });
      } else if (nodes.level == 2) {
        //下一级是题目的第二级。
        parmas.AppID = nodes.parent.label;
        parmas.ParentID = nodes.label;
        if (istong == "tongji") {
          //同级新增的情况下。
          parmas.AppID = nodes.parent.label;
          parmas.ParentID = -1;
        }
        this.$prompt("请输入名称", "温馨提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputValidator: this.checkfunc,
          closeOnClickModal: false,
        })
          .then(({ value }) => {
            this.$message({
              type: "success",
              message: "添加: " + value + "成功",
            });
            parmas.ChapterName = value;
            ChapterManager(parmas);
            this.getthreedata();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消输入",
            });
          });
      } else if (nodes.level == 3) {
        parmas.AppID = nodes.parent.parent.label;
        parmas.ParentID = nodes.label;
        if (istong == "tongji") {
          //同级新增的情况下。
          parmas.AppID = nodes.parent.parent.label;
          parmas.ParentID = nodes.parent.label;
        }
        this.$prompt("请输入名称", "温馨提示", {
          confirmButtonText: "确定",
          inputValidator: this.checkfunc,
          cancelButtonText: "取消",
        })
          .then(({ value }) => {
            this.$message({
              type: "success",
              message: "添加: " + value + "成功",
            });
            parmas.ChapterName = value;
            ChapterManager(parmas);
            this.getthreedata();
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "取消输入",
            });
          });
      }
    },
    // 修改
    ModifyThe(items, nodes) {
      console.log(items);
      console.log(nodes);
      let parmas = {
        CptID: nodes.label,
        ChapterName: "",
        UserID: JSON.parse(loginvuex.state.userlist).userID,
        Level: nodes.level,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
        _examID: "",
      };
      this.$prompt("请输入名称", "温馨提示", {
        confirmButtonText: "确定",
        inputValue: items.Name,
        cancelButtonText: "取消",
        inputValidator: this.checkfunc,
        closeOnClickModal: false,
      })
        .then(({ value }) => {
          this.$message({
            type: "success",
            message: "修改: " + value + "成功",
          });
          parmas.ChapterName = value;
          Update(parmas);
          this.getthreedata();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "取消输入",
          });
        });
      //   console.log(threeedata, "修改");
    },
    // 删除
    checkfunc(inputs) {
      if (inputs === "") {
        return false;
      }
      return true;
    },
    remove(items, nodes) {
      let parmas = {
        CptID: nodes.label,
        Level: nodes.level,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
        _examID: "",
      };
      this.$confirm(
        `一旦删除“${items.Name}”，该类目下的所有信息将不保存，确定删除“${items.Name}”吗?`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
          closeOnClickModal: false,
        }
      )
        .then(() => {
          if (nodes.level == 1 && this.threeedata.length == 0) {
            this.$parent.isaddtest = true;
            console.log(this.$parent.isaddtest);
          }
          Delete(parmas);
          this.getthreedata();
          this.$message({
            type: "success",
            message: "已删除",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //请求当前three的节点data
    async getthreedata() {
      let res = {
        ClassID: this.$parent.$parent.isselectitems.AppClassID,
        guid: JSON.parse(loginvuex.state.userlist).guid,
        userID: JSON.parse(loginvuex.state.userlist).userID,
        hid: JSON.parse(loginvuex.state.hid),
      };
      const Data = await ChapterThree(res);
      this.threeedata = Data.data.Data.Three;
      this.threeTrue(this.threeedata); // 用于筛选出默认展示的层级
      if (!Data.data.Data.Three) {
        return;
      }
      this.isfuappclassid = Data.data.Data.Three[0].ID;
      console.log(Data);
    },
    threeTrue(data) {
      // this.defaultExpandedKey = ['8bcb8ce9-6978-11ee-86d7-00163e0157d1']
      //  console.log(this.defaultExpandedKey);
      data.forEach((item) => {
        if (item.Childs.length !=0 && !item.Childs[0]?.lastNode) {
        // if (item.Childs.length !=0 &&   item?.lastNode == false) {
        // if (item.Childs[0].length ==0 || item.Childs[0] == undefined) {
          this.defaultExpandedKey.push(item.ID);
          this.threeTrue(item.Childs);
        } else {
          // 找到最后一层
          // console.log(this.defaultExpandedKey);
          console.log(item);
        }
      });
    },
    //导入试题的
    importtest(sdata, nodes) {
      console.log(sdata, nodes);
      this.isselectdata = JSON.parse(JSON.stringify(sdata));
      this.filedata = "";
      this.filename = "";
      this.dialogBoxVisible = true;
      if (nodes.level == 1) {
        this.isselectdata.ID = -1;
        this.isfuappclassid = sdata.ID;
      } else if (nodes.level == 2) {
        this.isfuappclassid = nodes.parent.label;
      } else if (nodes.level == 3) {
        this.isfuappclassid = nodes.parent.parent.label;
      }
    },
    //文件上传
    uploadPreview(file) {
      //文件上传，增加进度条，
      this.filename = file.name;
      let filetype = file.name.split(".");
      filetype = filetype[filetype.length - 1]; //文件类型。
      // filetype != "doc" &&
      //   filetype != "docx" &&
      if (
        // filetype == "doc" ||
        // filetype == "docx" ||
        // filetype != "xls" &&
        // filetype != "xlsx" &&
        // filetype != "ppt" &&
        // filetype != "pptx" &&
        // filetype != "txt" &&
        // filetype != "pdf" 
        filetype !='xls' && filetype !='xlsx'&& filetype !='doc'&& filetype !='docx'
      ) {
        this.$message({
          message: "文件格式不合法",
          type: "warning",
        });
        this.filename = "";
        this.$refs.upload.clearFiles(); //上传完了，再次点的时候是空的。
        return;
      } else if (file.raw.size > 10485760) {
        this.$message({
          message: "文件大小不能超过10MB",
          type: "warning",
        });
        this.filename = "";
        this.$refs.upload.clearFiles(); //上传完了，再次点的时候是空的。
        return;
      }
      // let formData = new FormData();
      // formData.append('file',file.raw);
      //  formData.append('size',6917606);
      //   console.log(formData);
      //   //开始进行base64转码
      //   let reader = new FileReader();
      //   reader.readAsDataURL(file.raw); //以base64读取文件
      //   reader.onload = (e) => {
      //     let basedata = reader.result;
      //     let splitIndex = basedata.indexOf(";base64,") + 8;
      //     let sendData = basedata.substring(splitIndex, basedata.length - 1);
      //     this.database = sendData
      // //   console.log(sendData);
      //   };
      this.filedata = file;
      this.$refs.upload.clearFiles(); //上传完了，再次点的时候是空的。
    },
    //确认发送请求
    send() {
      //必须有上传文件。
      console.log(this.filedata);
      if (this.filedata == "") {
        this.$message({
          message: "警告,当前未上传文件，请选择上传的文件",
          type: "warning",
        });
      } else {
        // 取到文件开始到最后一个点的长度
        let text = this.filedata.name.lastIndexOf(".");
        // 取到文件名长度
        let textlength = this.filedata.name.length;
        // 取到文件后缀
        let fileFormat = this.filedata.name.substring(text + 1, textlength);
        // this.sendupload();
        if (fileFormat == "doc" || fileFormat == "docx") {
          // 保存doc试题上传
          this.docUpload();
          console.log("执行doc");
        } else if (fileFormat == "xls" || fileFormat == "xlsx") {
          // 保存excel试题上传
          this.sendupload();
        }
      }
    },
    // excel上传方法
    async sendupload() {
      console.log('执行了');
      // this.isState = true;
      const formData = new FormData();
      formData.append("cptID", this.isselectdata.ID);
      formData.append("AppID", this.isfuappclassid);
      formData.append("userID", JSON.parse(loginvuex.state.userlist).userID);
      formData.append("guid", JSON.parse(loginvuex.state.userlist).guid);
      formData.append("ChapterName", this.isselectdata.Name);
      formData.append("name", this.filedata.name);
      formData.append("type", this.filedata.raw.type);
      formData.append("lastModifiedDate", new Date());
      formData.append("size", this.filedata.raw.size);
      formData.append("file", this.filedata.raw);
      console.log('参数',Object.fromEntries(formData.entries()),this.isselectdata.ID,);
      let res = await ImportExcel(formData);
      if (res.data.Status == 200) {
        this.$message({
          type: "success",
          message: "上传成功",
        });
        this.succeedNum = res.data.Data;
        this.getthreedata();
        setTimeout(() => {
          this.isState = false; // 防抖
        }, 500);
        this.dialogBoxVisible = false;
        this.successfulVisible = true; // 成功表格弹窗
      } else if (res.data.Status == 202) {
        this.flang = 1;
        this.failureData = res.data.Data;
        setTimeout(() => {
          this.isState = false; // 防抖
        }, 500);
        this.dialogBoxVisible = false;
        this.failureVisible = true;
      }else{
         setTimeout(() => {
          this.isState = false; // 防抖
        }, 500);
      }
    },
    // doc上传方法
    async docUpload() {
      this.isState = true;
      let formData = new FormData();
      formData.append("cptId", this.isselectdata.ID);
      formData.append("appId", this.isfuappclassid);
      formData.append("userId", JSON.parse(loginvuex.state.userlist).userID);
      formData.append("guid", JSON.parse(loginvuex.state.userlist).guid);
      formData.append("chapterName", this.isselectdata.Name);
      formData.append("file", this.filedata.raw);
      formData.append("hospital", JSON.parse(loginvuex.state.hid));
      const Data = await importWord(formData);
      console.log(Data);
      if (Data.data.code == 200 && Data.data.status == 1) {
        this.$message({
          type: "success",
          message: "上传成功",
        });
        this.succeedNum = Data.data.data.subjectTotal;
        this.getthreedata();
        setTimeout(() => {
          this.isState = false; // 防抖
        }, 500);
        this.dialogBoxVisible = false; // 关闭上传弹窗
        this.successfulVisible = true; // 成功表格弹窗
      } else if (Data.data.code == 200 && Data.data.status == 0) {
        this.flang = 0;
        this.failureData = Data.data.data.importWordErrorVoList;
        this.falngSum = Data.data.data.subjectTotal;
        setTimeout(() => {
          this.isState = false; // 防抖
        }, 500);
        this.dialogBoxVisible = false; // 关闭上传弹窗
        this.failureVisible = true;
      } else {
        this.$message.error(Data.data.message);
        setTimeout(() => {
          this.isState = false; // 防抖
        }, 500);
        this.dialogBoxVisible = false; // 关闭上传弹窗
      }
    },
    // excel文档模板下载
    excelDownload() {
      let a = document.createElement("a");
      a.href = `${process.env.BASE_URL}shitiexcel.xls`;
      a.setAttribute("download", "添加考生模板" + ".xls");
      a.download = "试题录题excel模板.xls";
      a.click();
    },
    //word文档模板下载
    docDownload() {
      let a = document.createElement("a");
      a.href = `${process.env.BASE_URL}shitiwrod.docx`;
      a.setAttribute("download", "添加考生模板" + ".docx");
      a.download = "试题录题word模板.docx";
      a.click();
    },
    //
  },
  created() {
    this.getthreedata();
  },
};
</script>

<style lang="scss" scoped>
.miancontent {
  width: 100%;
}
.back {
  border-bottom: 1px solid #eeeeee;
  padding: 10px 0px 9px 24px;
  background-color: #fff;
  border-radius: 0px 0px 10px 10px;
  i {
    display: inline-block;
    width: 12px;
    height: 12px;
    border-top: 2px solid #999999;
    border-left: 2px solid #999999;
    transform: scaleY(0.6) rotate(-45deg);
  }
  span {
    cursor: pointer;
    width: 47px;
    height: 25px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #999999;
  }
}
.mian_box {
  width: 100%;
  min-height: 540px;
  ::v-deep .el-card__body {
    padding: 0px;
    border-radius: 10px;
  }
}
.head_box {
  height: 60px;
  background: #8fcbff;
  border-radius: 4px 4px 0px 0px;
  display: flex;
  p {
    line-height: 60px;
    text-align: center;
    font-size: 15px;
    font-family: PingFang SC;
    font-weight: bold;
  }
  p:nth-child(1) {
    flex: 4;
  }
  p:nth-child(2) {
    flex: 1;
  }
}
::v-deep .el-tree-node__content {
  height: 67px;
}
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
  span {
    display: inline-block;
    .el-button--text {
      font-size: 16px;
    }
  }
  span:nth-child(2) {
    width: 320px;
    text-align: center;
  }
}
.el-tree-node__content {
  .el-checkbox__inner {
    display: inline-block;
    margin-right: 32px;
    display: none;
  }
  .el-tree-node__expand-icon.expanded {
    margin-right: 40px;
    margin-left: 20px;
    font-size: 28px;
  }
  .el-tree-node__expand-icon {
    margin-right: 40px;
    margin-left: 20px;
    font-size: 28px;
    display: inline-block;
  }
}
// 弹框头部样式
::v-deep .el-dialog__header {
  height: 55px;
  background: linear-gradient(180deg, #64b5ff 0%, rgba(199, 228, 255, 1) 100%);
  opacity: 1;
  border-radius: 5px 5px 0px 0px;
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #333333;
}

.dialog-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  .el-button:nth-child(1) {
    background: #eeeeee;
    opacity: 1;
    border-radius: 4px;
  }
  .el-button:nth-child(2) {
    background: #1890ff;
    opacity: 1;
    border-radius: 4px;
    margin-left: 50px;
  }
}
::v-deep .el-dialog__wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
::v-deep .examBox .el-dialog {
  width: 537px;
  height: 743px;
  border-radius: 5px 5px 0px 0px;
  .input_layout {
    display: flex;
    > .el-form-item {
      flex: 1;
      display: flex;
      align-content: center;
      ::v-deep .el-input {
        width: 420px;
      }
      .son_input > input {
        width: 420px;
      }
    }
  }
}

::v-deep .examBox .el-input {
  width: 380px;
}

::v-deep .examBox .el-form-item label {
  width: 100px !important;
  text-align: left;
  margin-left: 15px;
  font-size: 15px;
  font-weight: 400;
  line-height: 20px;
  font-family: "Microsoft YaHei";
}

.dialogBox {
  position: relative;
  margin-left: 24px;
  display: flex;
  ::v-deep .el-input__inner {
    &:focus {
      border-color: #c0c4cc;
    }
    &:hover {
      cursor: default !important;
    }
  }
  ::v-deep .el-input {
    width: 350px !important;
    margin-right: 20px;
  }
  .upoload {
    width: 150px !important;
    height: 40px !important;
    background: #1890ff;
    color: #ffffff;
  }
}
.instructions {
  width: 100%;
  height: 90px;
  line-height: 24px;
  margin-top: 32px;
  background: #f6f6f6;
  opacity: 1;
  border-radius: 4px;
  padding: 10px;
  h4 {
    font-family: Source Han Sans CN;
    font-weight: bold;
    font-size: 15px;
    color: #333333;
  }
  p {
    font-size: 12px;
    color: #999999;
  }
}

::v-deep .el-dialog__headerbtn .el-dialog__close {
  font-size: 24px;
}
// 批量导入考生
.bulkImportExaminee {
  display: flex;
  align-items: center;
  ::v-deep .el-dialog {
    width: 600px;
    height: 570px;
    background: #ffffff;
    opacity: 1;
    border-radius: 5px;
  }
}

::v-deep .bulkImportExaminee .el-input__inner {
  width: 350px !important;
}
.bulkImportExaminee .downloadExcel {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 30px;
  > div {
    width: 200px;
    height: 170px;
    background: #ffffff;
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.09);
    border-radius: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
  }
  .left_view {
    margin-right: 30px;
    .el-button {
      height: 40px;
      background: #1890ff;
      color: #ffffff;
      opacity: 1;
      border-radius: 4px;
    }
  }
  .right_view {
    .el-button {
      height: 40px;
      background: #00c972;
      color: #ffffff;
      opacity: 1;
      border-radius: 4px;
    }
  }
}

::v-deep .deleteBatches .el-dialog {
  width: 421px;
  height: 211px;
  background: #ffffff;
  opacity: 1;
  border-radius: 5px;
}

.el-switch__core {
  width: 50px;
  height: 24px;
  background: #1890ff;
  opacity: 1;
  border-radius: 100px;
}
::v-deep .el-tree-node__expand-icon {
  &::before {
    display: block;
    width: 24px;
    height: 24px;
    content: "";
    background-size: 100%;
    background-image: url("../../../../assets/qusetionbank/组 2831.png");
  }
}
::v-deep .el-tree-node {
  //hover和focus的阴影有问题
  padding-left: 20px;
  :hover {
    background-color: rgb(255, 255, 255);
  }
  :focus {
    background-color: rgb(255, 255, 255);
  }
}
::v-deep .is-current {
  background-color: #fff;
}
::v-deep .is-focusable {
  background-color: #fff;
}
::v-deep .el-tree-node__expand-icon.is-leaf {
  &::before {
    display: block;
    width: 24px;
    height: 24px;
    content: "";
    opacity: 0;
    background-size: 100%;
  }
}
::v-deep .el-tree-node__expand-icon.expanded {
  &::before {
    display: block;
    width: 24px;
    height: 24px;
    content: "";
    //  background-color: #333333;
    background-size: 100%;
    transform: rotate(90deg);
    background-image: url("../../../../assets/qusetionbank/组 2830.png");
  }
}
// 试题上传成功弹窗
.delete_view {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    // padding: 20px 24px 9px 24px;
    // padding-bottom: 9px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .el-dialog {
    width: 416px;
    height: 252px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
        .son_input > input {
          width: 420px;
        }
      }
    }
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: left !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog__footer span > button {
    width: 88px;
    //height: 32px;
    background: #1890ff !important;
    color: #ffffff;
    opacity: 1;
    border-radius: 4px;
  }
  .delete_mian {
    width: 368px;
    height: 65px;
    background: #f6f6f6;
    opacity: 1;
    border-radius: 4px;
    line-height: 22px;
    padding: 12px;
    p {
      span {
        color: #fd6161;
      }
    }
  }

  .el-dialog__footer span > button {
    margin-top: 10px;
  }
}
// 试题上传失败弹窗
.eroor_view {
  .title_box {
    // height: 54px;
    padding-bottom: 9px;
    margin-bottom: 20px;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: bold;
    line-height: 19px;
    color: #333333;
    border-bottom: 1px solid #abd7ff;
    // padding: 20px 24px 9px 24px;
    // padding-bottom: 9px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
  }
  ::v-deep .dialog-footer {
    margin-bottom: 30px;
  }
  ::v-deep.el-dialog__footer {
    justify-content: left !important;
  }
  span > button:nth-child(3) {
    margin-left: 50px;
  }
  ::v-deep .el-dialog {
    width: 813px;
    height: 604px;
    border-radius: 5px 5px 0px 0px;
    .input_layout {
      display: flex;
      > .el-form-item {
        flex: 1;
        display: flex;
        align-content: center;
        ::v-deep .el-input {
          width: 420px;
        }
        .son_input > input {
          width: 420px;
        }
      }
    }
  }
  .eroor_mian {
    p {
      color: #999999;
      font-size: 16px;
      margin-bottom: 22px;
    }
    .eroor_form {
      height: 370px;
      overflow-y: scroll;
      scrollbar-face-color: none !important;
      &::-webkit-scrollbar {
        /*滚动条整体样式*/
        width: 4px; /*高宽分别对应横竖滚动条的尺寸*/
        height: 4px;
      }
      &::-webkit-scrollbar-thumb {
        /*滚动条里面小方块*/
        border-radius: 5px;
        //  -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        background: linear-gradient(
          180deg,
          #64b5ff 0%,
          rgba(199, 228, 255, 1) 100%
        );
      }
      & ::-webkit-scrollbar-track {
        /*滚动条里面轨道*/
        // -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
        border-radius: 0;
        background: linear-gradient(
          180deg,
          #64b5ff 0%,
          rgba(199, 228, 255, 1) 100%
        );
      }
    }
    ::v-deep .el-table th > .cell {
      text-align: center;
    }
    ::v-deep .el-table .cell {
      text-align: center;
    }
  }

  ::v-deep .el-dialog__footer span > button {
    width: 88px;
    background: #1890ff !important;
    color: #ffffff;
    opacity: 1;
    border-radius: 4px;
  }
}
.green {
  color: #00c972 !important;
}
.red {
  color: #ff3131;
}
.mgr_20 {
  display: inline-block;
  margin-right: 20px;
}
</style>